exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timer[data-v-a8d53e2c] {\n  min-width: 150px;\n  max-width: 150px;\n  background-color: #3da2d8;\n  box-shadow: inset 0 0 0 13px white;\n  border-radius: 50%;\n  min-height: 150px;\n  max-height: 150px;\n}\n.prog-circle > h5[data-v-a8d53e2c] {\n  font-family: \"Roboto Condensed\", sans-serif;\n}", ""]);

// exports
